import React from "react";
import { Cloud } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function RequestAQuote() {
  return <section data-section-id="239020" id="request-a-quote" className="relative py-24 bg-primary overflow-hidden flex items-center justify-center min-h-[400px] dark">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
        <Cloud className="w-[600px] h-[600px] md:w-[800px] md:h-[800px] text-secondary opacity-10 animate-pulse" strokeWidth={0.5} />
      </div>

      {}
      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center text-center">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-foreground mb-6 font-default tracking-tighter uppercase">
          Need Bulk Pricing?
        </h2>
        
        <p className="text-xl md:text-2xl text-secondary mb-10 max-w-2xl font-default font-medium tracking-wide">
          Get specialized OEM quotes for high-volume marine spare parts orders.
        </p>
        
        <Button size="lg" className="rounded-md bg-transparent text-primary-foreground hover:bg-secondary hover:text-primary border-2 border-secondary shadow-md focus-visible:ring-secondary focus-visible:ring-offset-2 focus-visible:ring-offset-primary text-base md:text-lg px-8 h-14 font-semibold transition-all">
          Request a Quote
        </Button>
      </div>
    </section>;
}